export const APP_VERSION = '0.1.0';

const CACHE_TIDSPUNKT_KEY = 'forlagshuset:sw:installed-at';

let registrering: ServiceWorkerRegistration | null = null;
const oppdateringListeners = new Set<() => void>();

export function registrerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (import.meta.env?.DEV) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        registrering = reg;
        markerCachetidspunkt();
        reg.addEventListener('updatefound', () => {
          const installerende = reg.installing;
          if (!installerende) return;
          installerende.addEventListener('statechange', () => {
            if (
              installerende.state === 'activated' ||
              installerende.state === 'installed'
            ) {
              markerCachetidspunkt();
              oppdateringListeners.forEach((cb) => cb());
            }
          });
        });
      })
      .catch((err) => {
        console.warn('SW-registrering feilet', err);
      });
  });
}

function markerCachetidspunkt(): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(CACHE_TIDSPUNKT_KEY, new Date().toISOString());
  } catch {
    /* ignore */
  }
}

export function lesCacheTidspunkt(): Date | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(CACHE_TIDSPUNKT_KEY);
    if (!raw) return null;
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

export async function sjekkForOppdatering(): Promise<boolean> {
  if (!registrering) return false;
  try {
    await registrering.update();
    return true;
  } catch {
    return false;
  }
}

export function abonnerOppdatering(cb: () => void): () => void {
  oppdateringListeners.add(cb);
  return () => oppdateringListeners.delete(cb);
}
